import React from 'react';
import Typography from "@mui/material/Typography";
import IconButton from '@mui/material/IconButton';
// import { GiProgression } from "react-icons/gi";
// import { TbFileDollar } from "react-icons/tb";
// import { VscBriefcase } from "react-icons/vsc";
import {IoIosMedal} from "react-icons/io";
import {IoIosHome} from "react-icons/io";
import {IoIosPhotos} from "react-icons/io"
import Box from "@mui/material/Box";
import useQuery from "../../base/utils/UseQuery";
import {useNavigate} from "react-router-dom";

const ProjectRightMenuBar = () => {
    const query = useQuery()
    const pid = query.get('id')
    const navigate = useNavigate();
    return (
        <Box sx={{backgroundColor: '#5e6770', p: 1}}>
            <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <IconButton sx={{color: '#c2e7cb'}}
                            size="large"
                            aria-label="energy icon"
                            onClick={() => {
                                navigate("/projectInfo?id=" + pid)
                            }}
                >
                    <IoIosHome/>
                </IconButton>
                <Typography sx={{color: 'white'}}
                            variant="body2"
                            component="div"
                >
                    Project
                </Typography>
                <Typography sx={{color: 'white'}}
                            variant="body2"
                            component="div"
                >
                    Info
                </Typography>
            </Box>
            {/*<Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
            {/*    <IconButton sx={{color: '#c2e7cb'}}*/}
            {/*                size="large"*/}
            {/*                aria-label="energy icon"*/}
            {/*    >*/}
            {/*        <GiProgression/>*/}
            {/*    </IconButton>*/}
            {/*    <Typography sx={{color: 'white'}}*/}
            {/*        variant="body2"*/}
            {/*        component="div"*/}
            {/*    >*/}
            {/*        Financial*/}
            {/*    </Typography>*/}
            {/*    <Typography sx={{color: 'white'}}*/}
            {/*        variant="body2"*/}
            {/*        component="div"*/}
            {/*    >*/}
            {/*        Progress*/}
            {/*    </Typography>*/}
            {/*</Box>*/}
            <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <IconButton sx={{color: '#c2e7cb'}}
                            size="large"
                            aria-label="energy icon"
                            onClick={() => {
                                navigate("/project_physical_progress?id=" + pid)
                            }}
                >
                    <IoIosMedal/>
                </IconButton>
                <Typography sx={{color: 'white'}}
                            variant="body2"
                            component="div"
                >
                    Physical
                </Typography>
                <Typography sx={{color: 'white'}}
                            variant="body2"
                            component="div"
                >
                    Progress
                </Typography>
            </Box>
            <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <IconButton sx={{color: '#c2e7cb'}}
                            size="large"
                            aria-label="energy icon"
                            onClick={() => {
                                navigate("/photo_gallery?id=" + pid)
                            }}
                >
                    <IoIosPhotos/>
                </IconButton>
                <Typography sx={{color: 'white'}}
                            variant="body2"
                            component="div"
                >
                    Photo
                </Typography>
                <Typography sx={{color: 'white'}}
                            variant="body2"
                            component="div"
                >
                    Gallery
                </Typography>
            </Box>
            {/*<Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
            {/*    <IconButton sx={{color: '#c2e7cb'}}*/}
            {/*                size="large"*/}
            {/*                aria-label="energy icon"*/}
            {/*    >*/}
            {/*        <IoTimerOutline/>*/}
            {/*    </IconButton>*/}
            {/*    <Typography  sx={{color: 'white'}}*/}
            {/*        variant="body2"*/}
            {/*        component="div"*/}
            {/*    >*/}
            {/*        Time*/}
            {/*    </Typography>*/}
            {/*    <Typography  sx={{color: 'white'}}*/}
            {/*                 variant="body2"*/}
            {/*                 component="div"*/}
            {/*    >*/}
            {/*        Lapsed*/}
            {/*    </Typography>*/}
            {/*</Box>*/}
            {/*<Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
            {/*    <IconButton sx={{color: '#c2e7cb'}}*/}
            {/*                size="large"*/}
            {/*                aria-label="energy icon"*/}
            {/*    >*/}
            {/*        <VscBriefcase/>*/}
            {/*    </IconButton>*/}
            {/*    <Typography sx={{color: 'white'}}*/}
            {/*        variant="body2"*/}
            {/*        component="div"*/}
            {/*    >*/}
            {/*        Disbursment*/}
            {/*    </Typography>*/}
            {/*</Box>*/}
            {/*<Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
            {/*    <IconButton sx={{color: '#c2e7cb'}}*/}
            {/*                size="large"*/}
            {/*                aria-label="energy icon"*/}
            {/*    >*/}
            {/*        <TbFileDollar/>*/}
            {/*    </IconButton>*/}
            {/*    <Typography sx={{color: 'white'}}*/}
            {/*        variant="body2"*/}
            {/*        component="div"*/}
            {/*    >*/}
            {/*        Expenditure*/}
            {/*    </Typography>*/}
            {/*</Box>*/}
        </Box>
    );
}

export default ProjectRightMenuBar;
